import Vue from 'vue'
import Auth from '@aws-amplify/auth'
import Amplify from 'aws-amplify'

Vue.prototype.amplify = Amplify
Vue.prototype.$auth = Auth

Amplify.configure({
  Auth: {
    identityPoolId: process.env.VUE_APP_AWS_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_AWS_COGNITO_WEB_CLIENT_ID,
    userPoolId: process.env.VUE_APP_AWS_COGNITO_POOL_ID,
    region: process.env.VUE_APP_AWS_COGNITO_REGION
  },
  API: {
    endpoints: [
      {
        name: 'worktools',
        endpoint: process.env.VUE_APP_WORKTOOLS_BASE_API,
        custom_header: async () => {
          return { Authorization: `${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
        }
      }
    ]
  }
})
